import { styled } from '@linaria/react';
import { animated } from 'react-spring';

const Box = styled(animated.div)`
  width: 100px;
  height: 100px;
  background: white;
`;

export default Box;
